import { useEffect } from "react";
import { IS_PARTNER_DOMAIN } from "@/lib/api";

export let PHONE = "06 85 87 2878";
export let PHONE_TEL = "+390685872878";
export let SUPPORT_MAIL = "supporto@click2crm.it";
// white-label shops: contacts come from the partner configuration (set before the app renders)
export function setShopContacts(c) {
  PHONE = c?.phone || "";
  PHONE_TEL = PHONE ? `+39${PHONE.replace(/\D/g, "").replace(/^39/, "")}` : "";
  SUPPORT_MAIL = c?.email || "";
}
export const HOURS = "Lun–Ven 9:00–18:00";

export const SITE = IS_PARTNER_DOMAIN ? window.location.origin : (process.env.REACT_APP_SITE_URL || window.location.origin);

export const slugify = (s = "") => s.replace(/&/g, " e ").normalize("NFD").replace(/[\u0300-\u036f]/g, "")
  .toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
export const categoryUrl = (cat) => `/corsi/${slugify(cat)}`;
export const courseUrl = (c) => `/corsi/${slugify(c.category)}/${c.slug}`;

const setTag = (sel, make, attr, value) => {
  let el = document.head.querySelector(sel);
  if (!el) { el = make(); document.head.appendChild(el); }
  el.setAttribute(attr, value);
};

// Per-page SEO: title, description, canonical, Open Graph and JSON-LD.
const metaProp = (p, v) => setTag(`meta[property="${p}"]`, () => { const m = document.createElement("meta"); m.setAttribute("property", p); return m; }, "content", v);
const metaName = (n, v) => setTag(`meta[name="${n}"]`, () => Object.assign(document.createElement("meta"), { name: n }), "content", v);
const absUrl = (u) => (!u ? `${SITE}/icon-512.png` : u.startsWith("http") ? u : `${u.startsWith("/api/") && !IS_PARTNER_DOMAIN ? process.env.REACT_APP_BACKEND_URL : SITE}${u}`);

const cleanPath = (p) => (p.length > 1 ? p.replace(/\/+$/, "") : p).toLowerCase();

// Private / utility pages: never indexed, no canonical
export const PRIVATE_PATHS = ["/login", "/registrati", "/password-dimenticata", "/reset-password", "/verifica-email", "/profilo",
  "/i-miei-corsi", "/leggi/", "/payment/", "/collab/", "/amministrazione/", "/operatori/", "/cerca", "/abbonati"];
export const isPrivatePath = (p) => PRIVATE_PATHS.some((x) => p === x || p.startsWith(x.endsWith("/") ? x : x + "/"));

export function applyPrivateMeta(pathname) {
  if (!isPrivatePath(pathname)) return;
  metaName("robots", "noindex, nofollow");
  document.head.querySelector('link[rel="canonical"]')?.remove();
  document.head.querySelectorAll('script[data-seo="ld"]').forEach((e) => e.remove());
}

export function useSeo(title, description, { fullTitle = false, jsonLd = null, noindex = false, image = null, type = "website", canonical = null } = {}) {
  const ld = jsonLd ? JSON.stringify(jsonLd) : "";
  useEffect(() => {
    if (!title && !description) return;
    const img = absUrl(image);
    metaProp("og:image", img);
    metaProp("og:type", type);
    metaProp("og:locale", "it_IT");
    metaName("twitter:card", "summary_large_image");
    metaName("twitter:title", fullTitle ? title : `${title} | Corsando`);
    metaName("twitter:description", description || "");
    metaName("twitter:image", img);
  }, [title, description, fullTitle, image, type]);
  useEffect(() => {
    if (!title && !description) return;
    const t = fullTitle ? title : title ? `${title} | Corsando` : "Corsando — Corsi online illimitati";
    document.title = t;
    const url = SITE + cleanPath(canonical || window.location.pathname);
    setTag('meta[name="description"]', () => Object.assign(document.createElement("meta"), { name: "description" }), "content", description || "");
    setTag('link[rel="canonical"]', () => Object.assign(document.createElement("link"), { rel: "canonical" }), "href", url);
    setTag('meta[property="og:title"]', () => { const m = document.createElement("meta"); m.setAttribute("property", "og:title"); return m; }, "content", t);
    setTag('meta[property="og:description"]', () => { const m = document.createElement("meta"); m.setAttribute("property", "og:description"); return m; }, "content", description || "");
    setTag('meta[property="og:url"]', () => { const m = document.createElement("meta"); m.setAttribute("property", "og:url"); return m; }, "content", url);
    setTag('meta[name="robots"]', () => Object.assign(document.createElement("meta"), { name: "robots" }), "content", noindex ? "noindex, follow" : "index, follow, max-image-preview:large");
    document.head.querySelectorAll('script[data-seo="ld"]').forEach((e) => e.remove());
    if (ld) {
      const sc = document.createElement("script");
      sc.type = "application/ld+json"; sc.dataset.seo = "ld"; sc.textContent = ld;
      document.head.appendChild(sc);
    }
    applyPrivateMeta(window.location.pathname);
  }, [title, description, fullTitle, ld, noindex, canonical]);
}
